import { useEffect } from "react";

/** Adds the `visible` class to `.reveal` elements as they scroll into view. */
export function useScrollReveal() {
	useEffect(() => {
		const els = document.querySelectorAll(".reveal");
		const io = new IntersectionObserver(
			(entries) => {
				entries.forEach((e) => {
					if (e.isIntersecting) {
						e.target.classList.add("visible");
						io.unobserve(e.target);
					}
				});
			},
			{ threshold: 0.08, rootMargin: "0px 0px -40px 0px" }
		);
		els.forEach((el) => io.observe(el));
		return () => io.disconnect();
	}, []);
}
